import { FormattedMessage } from "react-intl";

import styles from "@components/carePlan/ExpertCarePlan.module.css";
import DateStamp from "@components/dates/DateStamp";
import ExpertAvatar from "@components/ExpertAvatar";
import NextConsultForm from "@components/forms/NextConsultForm";
import BodyCopy from "@components/typography/BodyCopy";
import { GetJourneyWithPlanQuery } from "@typing/Generated";

type Props = {
  journey: GetJourneyWithPlanQuery["journey"];
};

const NextConsult = ({ journey }: Props) => (
  <div>
    <div className={styles.nextConsultTitle}>
      <BodyCopy color="primary-300">
        <FormattedMessage id="pages.expertSection.nextRecommendedSession" />
      </BodyCopy>
    </div>
    <div className={styles.nextConsultContainer}>
      <div className={styles.expertAndTime}>
        {journey.primaryExpert && <ExpertAvatar expert={journey.primaryExpert} />}
        {journey.careProfile.nextConsult && (
          <div>
            <BodyCopy bold color="primary">
              <DateStamp value={journey.careProfile.nextConsult} />
            </BodyCopy>
          </div>
        )}
      </div>

      <NextConsultForm
        careProfileId={journey.careProfile.id}
        nextConsult={journey.careProfile.nextConsult}
        nextConsultDraft={journey.careProfile.nextConsultDraft}
      />
    </div>
  </div>
);

export default NextConsult;
